<template>
  <div class="ShopIndex">
    <ul>
      <li
        v-for="(item, index) in msg.shop.ticket"
        :key="index"
        @click="toShop()"
      >
        <!-- <img :src="item.product_img" alt=""> -->
        <van-image
          width="13.5rem"
          height="13.5rem"
          lazy-load
          :src="item.product_img"
        />
        <div class="shopListBot">
          <p class="shopTit">
            {{ item.product_name }}
          </p>
          <p class="shopPic">
            <span>￥</span>{{ item.sale_price }} <span>起</span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HomeVideo",
  props: ["msg"],
  methods: {
    toShop() {
      this.$toast("开发中，敬请期待");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

.ShopIndex ul{
  display flex
  flex-wrap wrap
  justify-content space-between
  padding-top 1rem
}

.ShopIndex li{
  width: 13.5rem;
  height: 18.3125rem;
  border: 1px solid #eee;
  margin-bottom .875rem
  border-radius .5rem
  overflow hidden
}

.ShopIndex li img{
  width 13.5rem
  height 8.0625rem
}

.shopListBot{
  box-sizing border-box
  padding .5rem
}
.shopTit{
  // height 2.75rem
  font-size:.875rem;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:1.375rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.shopPic{
  font-size:1.5rem;
  font-weight:bold;
  color:rgba(255,94,4,1);
  line-height:1.375rem;
  display flex
  align-items flex-end
  margin-top .625rem
}
.shopPic span{
  font-size .875rem
  line-height 0.875rem
}
</style>
